import { t } from "i18next";
import * as z from "zod";

/**
 * Schéma du motif d'une demande d'approbation maker-checker (guide §5.4) —
 * partagé : utilisé par les features qui soumettent une action protégée
 * (fee-engine, kyc, ledger) sans s'importer entre elles.
 * Factory mémoïsée au niveau composant sur la langue courante.
 */
export const createApprovalReasonSchema = () =>
  z.object({
    reason: z.string().trim().min(1, { message: t("requiredFieldError") }),
  });

export type ApprovalReasonFormValues = z.infer<
  ReturnType<typeof createApprovalReasonSchema>
>;
